import OnPremAgentClient from './OnPremAgentClient'

class OnPremAgentAPI {
  client: OnPremAgentClient
  constructor(client: OnPremAgentClient) {
    this.client = client
  }
}

export default OnPremAgentAPI
